import { useEffect, useState } from "react";
import api from "@/lib/api";
import SEO from "@/components/SEO";

export default function Gallery() {
  const [images, setImages] = useState(null);
  const [cat, setCat] = useState("");
  const [cats, setCats] = useState([]);

  useEffect(() => {
    api.get("/gallery").then((r) => {
      setImages(r.data);
      setCats([...new Set(r.data.map((i) => i.category))]);
    }).catch(() => setImages([]));
  }, []);

  const filtered = images ? (cat ? images.filter((i) => i.category === cat) : images) : null;

  return (
    <>
      <SEO title="Travel Gallery | Happy Holidays Wale" description="A glimpse into the breathtaking journeys our travelers have experienced." />
      <div className="bg-navy py-14" style={{ backgroundColor: "#002244" }}>
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <h1 className="font-display text-4xl font-extrabold text-white sm:text-5xl">Travel Gallery</h1>
          <p className="mt-3 text-white/70">Moments captured from unforgettable holidays.</p>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-8">
        <div className="mb-8 flex flex-wrap gap-2">
          <button onClick={() => setCat("")} className={`rounded-full px-4 py-2 text-sm font-semibold ${!cat ? "brand-gradient text-white" : "border border-gray-200 text-navy"}`}>All</button>
          {cats.map((c) => (
            <button key={c} data-testid={`gallery-filter-${c}`} onClick={() => setCat(c)} className={`rounded-full px-4 py-2 text-sm font-semibold ${cat === c ? "brand-gradient text-white" : "border border-gray-200 text-navy"}`}>{c}</button>
          ))}
        </div>
        {filtered === null ? (
          <div className="columns-2 gap-4 md:columns-3">{Array.from({ length: 8 }).map((_, i) => <div key={i} className="mb-4 h-52 skeleton rounded-2xl" />)}</div>
        ) : filtered.length === 0 ? (
          <p className="py-20 text-center text-gray-500" data-testid="gallery-empty">No images in this category yet.</p>
        ) : (
          <div className="columns-2 gap-4 md:columns-3 lg:columns-4">
            {filtered.map((img) => (
              <div key={img.id} className="mb-4 break-inside-avoid overflow-hidden rounded-2xl card-soft group">
                <img src={img.image} alt={img.title} loading="lazy" className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
